import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { PaperlessService } from '@services/_iam/paperless.service';
import { DataLayerService } from '@services/data-layer/data-layer.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-paperles-banner',
  templateUrl: './paperles-banner.component.html',
  styleUrls: ['./paperles-banner.component.scss'],
})
export class PaperlesBannerComponent implements OnInit {
  @Input() isAcmic: boolean;
  @ViewChild('contentRef') contentRef!: ElementRef<HTMLDivElement>;
  bannerImage: string;
  contentHeight = 180;
  user: any;

  constructor(
    private router: Router,
    private paperlessService: PaperlessService,
    private dataLayer: DataLayerService
  ) {}

  @HostListener('window:resize')
  onResize(){
    this.calculateBannerHeight();
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.bannerImage = this.isAcmic 
                          ? "/assets/img/images/paperless-banner.png" 
                          : "/assets/img/images/paperless-banner-new.png";
  }

  enrollInPaperless(gaLabel) {
    const event={
      name:'click_link',
      category:'remarked content',
      detail:'click banner',
      label:gaLabel
    }
    this.dataLayer.pushEvent(event);
    this.router.navigate(['/billing/paperless']);
  }

  notNow(gaLabel) {
    const event={
      name:'click_link',
      category:'remarked content',
      detail:'click banner',
      label:gaLabel
    }
    this.dataLayer.pushEvent(event);
    this.paperlessService
      .snoozePaperless(this.user.username)
       .subscribe({
        next: () => this.paperlessService.UpdatePaperlessOnSnooze(true),
        error: () => {
          console.log("Error during snoozePaperless in DEV env")
          this.paperlessService.UpdatePaperlessOnSnooze(true)
        }
      });      
  }

  private calculateBannerHeight() {
    if(window.innerWidth > 767){
      this.contentHeight = this.contentRef.nativeElement?.offsetHeight
    } else {
      this.contentHeight = 118;
    }
  }
}
